import React from 'react';
import classNames from 'classnames';
import classes from './RngResultItem.module.scss';

interface IProps {
    className?: string;
}

export const RngResultItem: React.FC<React.PropsWithChildren<IProps>> = (props) => (
    <div className={classNames(classes.container, props.className)}>{props.children}</div>
);
